import { render, staticRenderFns } from "./ENotas.vue?vue&type=template&id=47fde594&"
import script from "./ENotas.vue?vue&type=script&lang=js&"
export * from "./ENotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports